module.exports = __webpack_public_path__ + "img/Prototype_design.431cdfef.jpg";